import * as React from "react";
import { IProfile } from "@/types/profile";
import { Mail } from "lucide-react";

export const ContactsList = ({ profiles }: { profiles: IProfile[] }) => (
  <div className="space-y-4 my-12">
    {profiles.map((profile: IProfile) => (
      <React.Fragment key={profile.sys.id}>
        <a
          href={`mailto:${profile.email}`}
          className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 flex justify-between items-center"
        >
          <div>
            <h5 className="font-medium text-lg">
              {profile.firstname} {profile.lastname}
            </h5>
            <p className="text-gray-600">{profile.position}</p>
          </div>
          <div>
            <Mail />
          </div>
        </a>
      </React.Fragment>
    ))}
  </div>
);
